module.exports = __webpack_public_path__ + "img/frown_active.667175e1.svg";